
//$(document).ready(function() {
	//$('#IndiaPanFrontTick').hide();
	//$('#IndiaPassportFrontTick').hide();
	//$('#livenessTick').hide();
 //   $("#PhotoDiv").hide();
 //   $('#submitDocuments').hide();
	
	//var panAvailable='0';
	//var passportAvailable='0';
	//var livenessAvailable='0';

	//var decodeUrl= function (url) {
 //       return decodeURIComponent(url);
	//}

	//var queryStringObject = "";
 //   var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

 //   for (var i = 0; i < url.length; i++) {
 //       var urlparam = url[i].split('=');
 //       if (urlparam.length > 1) {
 //           queryStringObject += decodeUrl(urlparam[0]) + ":" + ((urlparam.length > 1 && urlparam[1]) ? decodeUrl(urlparam[1]) : "");
 //       }
 //   }
	
	//queryStringObject = url[0].split("=")[1];
	//if(queryStringObject.substring(queryStringObject.length-2,queryStringObject.length)=="-1"){
	//	queryStringObject = queryStringObject.substring(0,queryStringObject.length-2);
	//}
	//panAvailable=url[1].split("=")[1];
	//passportAvailable=url[2].split("=")[1];
	//livenessAvailable=url[3].split("=")[1];
	//if (panAvailable=='1'){
	//	// $('#IndiaPanFrontTick').show();
	//}
	//if (passportAvailable=='1'){
	//	// $('#IndiaPassportFrontTick').show();
	//}
	//if (livenessAvailable=='1'){
	//	// $('#livenessTick').show();
	//}
	//// queryStringObject="123";
	//var idString = queryStringObject.toString()+"-1";
	

	//var UserguidValue = queryStringObject.toString()+"-1";

	//$('.loadingPic').hide();

	//if (jQuery.browser.mobile) {
		
 //       $('#capturedPhoto1').click(function() {
	//		$('#capture1').click();
	//	});
 //       $('#capturedPhoto2').click(function() {
	//		$('#capture2').click();
	//	});	
 //       $('#capturedPhoto3').click(function() {
 //           $('#capture3').click();
 //       }); 
 //       $('#capturedPhoto4').click(function () {
 //           $('#capture4').click();
 //       });

 //       $('#capturedPhoto6').click(function () {
 //           $('#capture6').click();
 //       });
 //       $('#capturedPhoto7').click(function () {
 //           $('#capture7').click();
 //       });
	//} else {
	//	// alert("Please browse page on mobile");
 //       $('#capturedPhoto1').click(function () {
 //           $('#capture1').click();
 //       });
 //       $('#capturedPhoto2').click(function () {
 //           $('#capture2').click();
 //       });
 //       $('#capturedPhoto3').click(function () {
 //           $('#capture3').click();
 //       });
 //       $('#capturedPhoto4').click(function () {
 //           $('#capture4').click();
 //       });

 //       $('#capturedPhoto6').click(function () {
 //           $('#capture6').click();
 //       });
 //       $('#capturedPhoto7').click(function () {
 //           $('#capture7').click();
 //       });
	//}
    import $ from 'jquery';
    import jic from '@/customJs/JIC.min.js';
    import Vue from 'vue';

// Define the reactive state
export const state = Vue.observable({
    isDisableUploadBtn: false,
    isFrontImgUploaded: false,
    isBckImgUploaded: false
});

export const methods = {
    setDisableUploadBtn(value) {
      state.isDisableUploadBtn = value;
    },
    setFrontImgUploaded(value) {
      state.isFrontImgUploaded = value;
    },
    setBckImgUploaded(value) {
      state.isBckImgUploaded = value;
    },
  };

	function getOrientation(file, callback) {
    var reader = new FileReader();
    reader.onload = function(e) {

        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) != 0xFFD8)
        {
            return callback(-2);
        }
        var length = view.byteLength, offset = 2;
        while (offset < length) 
        {
            if (view.getUint16(offset+2, false) <= 8) return callback(-1);
            var marker = view.getUint16(offset, false);
            offset += 2;
            if (marker == 0xFFE1) 
            {
                if (view.getUint32(offset += 2, false) != 0x45786966) 
                {
                    return callback(-1);
                }

                var little = view.getUint16(offset += 6, false) == 0x4949;
                offset += view.getUint32(offset + 4, little);
                var tags = view.getUint16(offset, little);
                offset += 2;
                for (var i = 0; i < tags; i++)
                {
                    if (view.getUint16(offset + (i * 12), little) == 0x0112)
                    {
                        return callback(view.getUint16(offset + (i * 12) + 8, little));
                    }
                }
            }
            else if ((marker & 0xFF00) != 0xFF00)
            {
                break;
            }
            else
            { 
                offset += view.getUint16(offset, false);
            }
        }
        return callback(-1);
    };
    reader.readAsArrayBuffer(file);
}

	function resetOrientation(srcBase64, srcOrientation, callback) {
		var img = new Image();	

		img.onload = function () {
        var width = img.width,
            height = img.height,
            canvas = document.createElement('canvas'),
            ctx = canvas.getContext("2d");

        var req_width = width;
        var req_height = height;

        if (width >= height) {
            req_height = parseInt(1600 * height / width);
            req_width = 1600;
        }
        else {
            req_width = parseInt(1600 * width / height);
            req_height = 1600;
        }

        width = req_width;
        height = req_height;

        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
            canvas.width = height;
            canvas.height = width;
        } else {
            canvas.width = width;
            canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
            case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
            case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
            case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
            case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
            case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
            case 7: ctx.transform(0, -1, -1, 0, height, width); break;
            case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
            default: break;
        }

        // draw image
        ctx.drawImage(img, 0, 0, req_width, req_height);

        // export base64
        //callback(canvas.toDataURL());
    };
        callback(srcBase64);
		img.src = srcBase64;
}
	// function correctOrientationOfElement(imageId, orientation){
	// 	var img = document.getElementById(imageId);
	// 	if (orientation==3){
	// 		img.style.transform = 'rotate(180deg)';

	// 	}
	// 	else if (orientation==6){
	// 		// alert("changing orien")
				
	// 		img.style.transform = 'rotate(90deg)';
	// 		// alert('rotated')
	// 	}
	// 	else if (orientation==8){
	// 		img.style.transform = 'rotate(270deg)';
	// 	}
	// 	img.style.margin = 20;
	// }

    export function readURL1(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();
            
                reader.onload = function (e) {
                    $('#capturedPhoto1').attr('src', e.target.result);
                //  $(".default_image").hide();
                    $('#capturedPhoto1').show();
                
                
                    // $('#IndiaPanFrontTick').show();
                    getOrientation(input.files[0], function (orientation) {
                    
                        // correctOrientationOfElement('capturedPhoto1',orientation);
                        var originalImage = document.getElementById("capturedPhoto1");
                        resetOrientation(originalImage.src, orientation, function(resetBase64Image) {
                        originalImage.src = resetBase64Image;
                        $('#capturedPhoto1').show();
                        methods.setFrontImgUploaded(true);
                        if(state.isFrontImgUploaded && self.isBckImgUploaded){
                            methods.setDisableUploadBtn(true);
                            console.log("1111111::::", state.isFrontImgUploaded)
                        }
                        console.log("111else::::", state.isFrontImgUploaded)
                        //  $('#submitDocuments').show();
                    // alert('orientation: ' + orientation);
                    });
                    });
                }
                reader.readAsDataURL(input.files[0]);
                // $(".default_image").hide();
                $('#capturedPhoto1').show();
                // $("#submitDocuments").show();
            // panAvailable='1';
                // $('#IndiaPanFrontTick').show();
                
            }
        }
	export function readURL2(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                $('#submitDocuments').hide();
                reader.onload = function (e) {
                    $('#capturedPhoto2').attr('src', e.target.result);
                    $('#capturedPhoto2').show();
                    
                    getOrientation(input.files[0], function(orientation) {

                    var originalImage = document.getElementById("capturedPhoto2");
                    resetOrientation(originalImage.src, orientation, function(resetBase64Image) {
                    originalImage.src = resetBase64Image;
                     $('#capturedPhoto2').show();
                     methods.setBckImgUploaded(true);
                     if(state.isFrontImgUploaded && self.isBckImgUploaded){
                        methods.setDisableUploadBtn(true);
                        console.log("2222222::::", state.isBckImgUploaded)
                    }
                     
                    //  $('#submitDocuments').show();
                // alert('orientation: ' + orientation);
                });
                });
                
                }
                reader.readAsDataURL(input.files[0]);
            //  $(".default_image").hide();

                $('#capturedPhoto2').show();
                
            
                // $('#IndiaPassportFrontTick').show();
            }
	}
    export function readURL3(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            $('#submitDocuments').hide();
            reader.onload = function (e) {
                $('#capturedPhoto11').attr('src', e.target.result);
              //   $(".default_image").hide();
                $('#capturedPhoto11').show();

                // $('#IndiaPassportFrontTick').show();
                // passportAvailable='1';
               getOrientation(input.files[0], function(orientation) {
                    // alert('orientation: ' + orientation);

                   var originalImage = document.getElementById("capturedPhoto11");
                    resetOrientation(originalImage.src, orientation, function(resetBase64Image) {
                    originalImage.src = resetBase64Image;
                        $('#capturedPhoto11').show();
                     $('#submitDocuments').show();
                // alert('orientation: ' + orientation);
                });
                });
                
            
            }
            reader.readAsDataURL(input.files[0]);
           //  $(".default_image").hide();
            $('#capturedPhoto11').show();
           // $("#PhotoDiv").show();
            $('#submitDocuments').show();
            // $('#IndiaPassportFrontTick').show();
        }
    }

   export function readURL4(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            $('#submitDocuments').hide();
            reader.onload = function (e) {
                $('#capturedPhoto6').attr('src', e.target.result);
                //   $(".default_image").hide();
                $('#capturedPhoto6').show();

                // $('#IndiaPassportFrontTick').show();
                // passportAvailable='1';
                getOrientation(input.files[0], function (orientation) {
                    // alert('orientation: ' + orientation);
                 
                    var originalImage = document.getElementById("capturedPhoto6");
                    resetOrientation(originalImage.src, orientation, function (resetBase64Image) {
                        originalImage.src = resetBase64Image;
                        $('#capturedPhoto6').show();
                        console.log("444444444444")
                        // $('#submitDocuments').show();
                        // alert('orientation: ' + orientation);
                    });
                });


            }
            reader.readAsDataURL(input.files[0]);
            //  $(".default_image").hide();
            $('#capturedPhoto6').show();
            // $("#PhotoDiv").show();
            $('#submitDocuments').show();
            // $('#IndiaPassportFrontTick').show();
        }
    }


    export function readURL5(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            $('#submitDocuments').hide();
            reader.onload = function (e) {
                $('#capturedPhotoAadhaarfront').attr('src', e.target.result);
                //   $(".default_image").hide();
                $('#capturedPhotoAadhaarfront').show();
               
                // $('#IndiaPassportFrontTick').show();
                // passportAvailable='1';
                getOrientation(input.files[0], function (orientation) {
                    // alert('orientation: ' + orientation);

                    var originalImage = document.getElementById("capturedPhotoAadhaarfront");
                    resetOrientation(originalImage.src, orientation, function (resetBase64Image) {
                        originalImage.src = resetBase64Image;
                        $('#capturedPhotoAadhaarfront').show();
                        $('#submitDocuments').show();
                        // alert('orientation: ' + orientation);
                    });
                });


            }
            reader.readAsDataURL(input.files[0]);
            //  $(".default_image").hide();
            $('#capturedPhotoAadhaarfront').show();
            // $("#PhotoDiv").show();
            $('#submitDocuments').show();
            // $('#IndiaPassportFrontTick').show();
        }
    }

    export function readURL6(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            $('#submitDocuments').hide();
            reader.onload = function (e) {
                $('#capturedPhotoAadhaarBack').attr('src', e.target.result);
                //   $(".default_image").hide();
                $('#capturedPhotoAadhaarBack').hide();

                // $('#IndiaPassportFrontTick').show();
                // passportAvailable='1';
                getOrientation(input.files[0], function (orientation) {
                    // alert('orientation: ' + orientation);
                   
                    var originalImage = document.getElementById("capturedPhotoAadhaarBack");
                    resetOrientation(originalImage.src, orientation, function (resetBase64Image) {
                        originalImage.src = resetBase64Image;
                        $('#capturedPhotoAadhaarBack').show();
                        $('#submitDocuments').show();
                        // alert('orientation: ' + orientation);
                    });
                });


            }
            reader.readAsDataURL(input.files[0]);
            //  $(".default_image").hide();
            $('#capturedPhotoAadhaarBack').show();
            // $("#PhotoDiv").show();
            $('#submitDocuments').show();
            // $('#IndiaPassportFrontTick').show();
        }
    }

    export function readURL7(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        $('#submitDocuments').hide();
        reader.onload = function (e) {
            $('#capturedPhotoNationalID').attr('src', e.target.result);
            //   $(".default_image").hide();
            $('#capturedPhotoNationalID').hide();

            // $('#IndiaPassportFrontTick').show();
            // passportAvailable='1';
            getOrientation(input.files[0], function (orientation) {
                // alert('orientation: ' + orientation);

                // correctOrientationOfElement('capturedPhoto1',orientation);
                var originalImage = document.getElementById("capturedPhotoNationalID");
                resetOrientation(originalImage.src, orientation, function (resetBase64Image) {
                    originalImage.src = resetBase64Image;
                    $('#capturedPhotoNationalID').show();
                    $('#submitDocuments').show();
                    // alert('orientation: ' + orientation);
                });
            });


        }
        reader.readAsDataURL(input.files[0]);
        //  $(".default_image").hide();
        $('#capturedPhotoNationalID').show();
        // $("#PhotoDiv").show();
        $('#submitDocuments').show();
        // $('#IndiaPassportFrontTick').show();
    }
}
    export function readURL10(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        $('#submitDocuments').hide();
        reader.onload = function (e) {
            $('#capturedPhotoNationalIDBack').attr('src', e.target.result);
            //   $(".default_image").hide();
            $('#capturedPhotoNationalIDBack').hide();

            // $('#IndiaPassportFrontTick').show();
            // passportAvailable='1';
            getOrientation(input.files[0], function (orientation) {
                // alert('orientation: ' + orientation);

                // correctOrientationOfElement('capturedPhoto1',orientation);
                var originalImage = document.getElementById("capturedPhotoNationalIDBack");
                resetOrientation(originalImage.src, orientation, function (resetBase64Image) {
                    originalImage.src = resetBase64Image;
                    $('#capturedPhotoNationalIDBack').show();
                    console.log("national id back")
                    // $('#submitDocuments').show();
                    // alert('orientation: ' + orientation);
                });
            });


        }
        reader.readAsDataURL(input.files[0]);
        //  $(".default_image").hide();
        $('#capturedPhotoNationalIDBack').show();
        // $("#PhotoDiv").show();
        $('#submitDocuments').show();
        // $('#IndiaPassportFrontTick').show();
    }
}

export function readURL8(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        $('#submitDocuments').hide();
        reader.onload = function (e) {
            $('#capturedPhotoEmiratesID').attr('src', e.target.result);
            //   $(".default_image").hide();
            $('#capturedPhotoEmiratesID').hide();

            // $('#IndiaPassportFrontTick').show();
            // passportAvailable='1';
            getOrientation(input.files[0], function (orientation) {
                // alert('orientation: ' + orientation);

                // correctOrientationOfElement('capturedPhoto1',orientation);
                var originalImage = document.getElementById("capturedPhotoEmiratesID");
                resetOrientation(originalImage.src, orientation, function (resetBase64Image) {
                    originalImage.src = resetBase64Image;
                    $('#capturedPhotoEmiratesID').show();
                    $('#submitDocuments').show();
                    // alert('orientation: ' + orientation);
                });
            });


        }
        reader.readAsDataURL(input.files[0]);
        //  $(".default_image").hide();
        $('#capturedPhotoEmiratesID').show();
        // $("#PhotoDiv").show();
        $('#submitDocuments').show();
        // $('#IndiaPassportFrontTick').show();
    }
}
 

export function readURL9(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        $('#submitDocuments').hide();
        reader.onload = function (e) {
            $('#capturedPhotoEmiratesIDBack').attr('src', e.target.result);
            //   $(".default_image").hide();
            $('#capturedPhotoEmiratesIDBack').hide();

            // $('#IndiaPassportFrontTick').show();
            // passportAvailable='1';
            getOrientation(input.files[0], function (orientation) {
                // alert('orientation: ' + orientation);

                // correctOrientationOfElement('capturedPhoto1',orientation);
                var originalImage = document.getElementById("capturedPhotoEmiratesIDBack");
                resetOrientation(originalImage.src, orientation, function (resetBase64Image) {
                    originalImage.src = resetBase64Image;
                    $('#capturedPhotoEmiratesIDBack').show();
                    $('#submitDocuments').show();
                    // alert('orientation: ' + orientation);
                });
            });


        }
        reader.readAsDataURL(input.files[0]);
        //  $(".default_image").hide();
        $('#capturedPhotoEmiratesIDBack').show();
        // $("#PhotoDiv").show();
        $('#submitDocuments').show();
        // $('#IndiaPassportFrontTick').show();
    }
}

export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

	export function setProgressBar(currentStep)
	{
		var step = currentStep;
		var percent = (parseInt(step) / 2) * 100;
		$('.progress-bar').css({width: percent + '%'});
	}

	// $('#liveness').on('click',function(){

	// 	if (jQuery.browser.ios){
	// 		window.location = "liveness_landingPage.html?userid="+queryStringObject.toString()+"-1&p1="+panAvailable+"&p2="+passportAvailable+"&l1="+livenessAvailable;
	// 	}
	// 	else{

	// 		window.location="liveness.html?userid="+queryStringObject.toString()+"-1&p1="+panAvailable+"&p2="+passportAvailable+"&l1="+livenessAvailable;
	// 	}
	// });

	$('#submitDocuments1').click(function () {  
		
		const Compress = require(['@/customJs/compressjs']);
		// eslint-disable-next-line no-unused-vars
		const compress = new Compress();
		const source_imageNationalID = $('#capturedPhoto1')[0];
		const source_imagePassport = $('#capturedPhoto2')[0];
        const source_imagePhoto = $('#capturedPhoto3')[0];

		var d = new Date();
        // eslint-disable-next-line no-unused-vars
        var n = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();

		// var resultPanImage = jic.compress(source_imageNationalID,90,'').src;
		var resultNationalIDImage = jic.compress(source_imageNationalID,90,'').src;
		var resultPassportImage = jic.compress(source_imagePassport,90,'').src;
        var resultPhoto = jic.compress(source_imagePhoto,90,'').src;

		// eslint-disable-next-line no-unused-vars
		var k = new Date();
		
        var formData = new FormData();
		$(".info").fadeOut();	
		$(".loadingPic").fadeIn(500);
		$(".loadingPic .icon_holder .default_image").show();
		formData.append('image', 'IndiaPanFront,'+ resultNationalIDImage.split(',')[1]);
		formData.append('image', 'IndiaPassportFront,'+ resultPassportImage.split(',')[1]);
		// eslint-disable-next-line no-undef
		formData.append('clientUserId',idString);
        formData.append('isios',this.isIOS);
        formData.append('photo', 'Photo,'+ resultPhoto.split(',')[1]);
		
            $.ajax({
            url : 'https://skylake.westus2.cloudapp.azure.com/upload/',
            type : 'POST',
            data : formData,
            processData: false,  // tell jQuery not to process the data
            contentType: false,  // tell jQuery not to set contentType
            success : function() {
                    $(".progress-bar").css("width","50%");
                    $('#step2').show();
                    $('#step1').hide();
                    $.ajax({
                        // eslint-disable-next-line no-undef
                        url : 'https://skylake.westus2.cloudapp.azure.com/runfiles/?userid='+(idString),
                        type : 'GET',
                        success : function(data){
                            console.log(data)
                            //setProgressBar(2);
                            // var processingTime = data.split(",")[2];
                            $(".progress-bar").css("width","100%");
                            $(".loadingPic .icon_holder .default_image").hide();
                            $(".loadingPic .icon_holder .default_image2").fadeIn(500);
                            $('#step2').hide();				   		
                            $('#step3').show();
                            setTimeout(function(){
                            // eslint-disable-next-line no-undef
                            window.location = "../genz/clientphoto.html?userid="+UserguidValue;
                            },3000);
                        },
                        error: function(ex){
                            console.log(ex);
                            alert("Network error: Something is wrong with your internet connection. Please try again after restoring the connection.");
                        }
                    });

                },
                error: function(ex){
                    console.log(ex);
                    alert("Network error: Something is wrong with your internet connection. Please try again after restoring the connection.");
                }
            });
	});
//});